<template>
  <div v-if="authenticatedUser">
    <!-- Successful Group Join modal -->
    <b-modal id="modal-1" ok-only title="Success">
      <p class="my-2">You have successfully joined this group!</p>
    </b-modal>
    <!-- Successful Group Member Acceptance modal -->
    <b-modal @ok="ExpellSuccessOk" id="modal-2" ok-only title="Success">
      <p class="my-2">The applicant has been added to your group!</p>
    </b-modal>

    <b-modal @ok="ExpellSuccessOk" id="modal-3" ok-only title="Success">
      <p class="my-2">
        The user has successfully become a member of this group!
      </p>
    </b-modal>

    <b-modal id="modal-4" ok-only title="Success">
      <p class="my-2">
        The user will become a member once she/he accepts the invitation!
      </p>
    </b-modal>

    <b-modal
      @ok="ExpellOk"
      id="modal-expell"
      ok-title="Expell"
      ok-variant="danger"
      ref="modal"
      title="Expell"
      ><p class="my-2">Are you sure you wish to expell this member?</p>
    </b-modal>

    <b-modal
      @ok="ExpellSuccessOk"
      id="modal-expell-Success"
      ref="modal"
      title="Success"
      ><p class="my-2">
        The user has been successfully expelled from this group!
      </p>
    </b-modal>

    <b-modal
      @ok="handleInvitationOk"
      id="modal-invite"
      ok-title="Invite"
      ok-variant="danger"
      ref="modal"
      title="Invite someone to join this group"
    >
      <p class="my-2">Whom do you wish to invite?</p>

      <Autocomplete :EventBus="sendChosenLogin3"></Autocomplete>
    </b-modal>

    <b-modal
      @cancel="RejectCancel"
      @ok="AcceptOk"
      cancel-title="Reject"
      id="modal-9"
      ok-title="Accept"
      ok-variant="danger"
      title="Accept another user to this group"
    >
      <p class="my-2">Whose request will you answer to?</p>

      <Autocomplete :EventBus="sendChosenLogin3"></Autocomplete>
    </b-modal>

    <b-container class="mt-5">
      <b-card
        :img-src="bannerImgUrl"
        img-alt="Banner image"
        img-top
        no-body
        tag="article"
      >
        <b-card-body>
          <b-card-title class="text-left">
            <b-media tag="li">
              <template v-slot:aside>
                <div class="bg-gray pl-3 pr-3 pt-4 mr-5" id="media-wrapper">
                  <font-awesome-icon
                    class="text-white align-middle"
                    icon="users"
                    size="3x"
                  ></font-awesome-icon>
                </div>
                <h3 class="pt-5 align-middle">{{ group.name }}</h3>

                <span>
                                   <a class="text-dark"
                                       title="Edit this group"
                                       v-b-tooltip.hover.top
                                       v-if="isCreatedbyOwner"
                                    @click="goToEditView"   
                                   >
                  <b-button class="btn btn-sm btn-dark">
                                      <font-awesome-icon icon="edit" size="sm"/>
                                        Edit
                                      </b-button>
                                    </a>
                                    <b-link class="text-danger"
                                            title="Delete the group"
                                            v-b-tooltip.hover.top
                                          v-if="isCreatedbyOwner">
                                    </b-link>
                                    <b-button class="btn bg-orange btn-sm" title="Delete this group"
                                    @click="showMsgDelete()"
                                     v-b-tooltip.hover.top
                                     v-if="isCreatedbyOwner">
                                     <font-awesome-icon icon="trash-alt" size="sm"/>
                                      Delete
                                    </b-button>
                  <!--                  <b-button title="Not available yet" @click="showMsgInvite()" class="btn bg-orange btn-sm" v-if="isCreatedbyOwner" v-b-tooltip.hover.top>-->
                  <b-button
                    @click="showMsgInvite()"
                    class="btn bg-orange btn-sm"
                    v-if="isCreatedbyOwner"
                  >
                    Invite to this group
                  </b-button>
                  <!--              <b-button title="Not available yet" @click="showMsgAcceptReject()" class="btn bg-orange btn-sm" v-if="isCreatedbyOwner" v-b-tooltip.hover.top>-->
                  <b-button
                    @click="showMsgAcceptReject()"
                    class="btn bg-orange btn-sm"
                    v-if="isCreatedbyOwner"
                  >
                    Reply to join requests
                  </b-button>
                  <!--              <b-button class="btn bg-orange btn-sm" title="Not available yet" v-b-tooltip.hover.top>-->
                  <!--                Leave-->
                  <!--              </b-button>-->
                  <b-link
                    class="text-info"
                    title="Share the recipe"
                    v-b-tooltip.hover.top
                  >
                  </b-link>
                </span>
              </template>
            </b-media>
            <hr />
          </b-card-title>

          <b-card-text class="text-justify">
            <p>
              <span title="Owner of the group" v-b-tooltip.hover.right>
                <font-awesome-icon icon="user" /> {{ getOwner }}
              </span>
            </p>
            <p>
              <span title="Creation date" v-b-tooltip.hover.right>
                <font-awesome-icon icon="calendar-alt" />
                {{ group.created | utcLocalDate }}
              </span>
            </p>
            <!-- <p>
            <span>
              Need for group consent? {{ group.needGroupConsent | needConsent }}
            </span>
            </p>

            <p>
            <span>
               Need for member consent? {{ group.needMemberConsent | needConsent }}
            </span>
            </p> -->
          </b-card-text>
          <hr />
          <h3 class="pt-5 align-middle" v-if="isCreatedbyOwner">
            {{ group.name }} Members
          </h3>
          <MembersSection></MembersSection>
        </b-card-body>
      </b-card>
    </b-container>
  </div>
  <div v-else>
    <section class="pb-lg-5 pt-lg-5">
      <b-jumbotron bg-variant="white">
        <template v-slot:header>You do not have access to this page.</template>
        <!--        <h3>-->
        <!--          <p>Please login first.</p>-->
        <!--        </h3>-->
        <br />
        <br />
        <h3>
          <router-link :to="{ name: 'home' }">Home page</router-link>
          |
          <router-link :to="{ name: 'login' }">Login</router-link>
        </h3>
      </b-jumbotron>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import bannerImg from "../assets/group-banner.jpg";
import MembersSection from "../components/groups/MembersSection";
import Autocomplete from "./Autocomplete";
import { eventBus } from "./../main";
import axios from "axios";

export default {
  name: "GroupView",
  data() {
    return {
      bannerImgUrl: bannerImg,
      group: {},
      UserLogin: this.$store.state.user.login,
      groupToBeInvited: "",
      MemberToBeExpelled: "",
      value3: "",
      sendChosenLogin3: "sendAAA",
      userID2: "",
    };
  },
  watch: {
    $route(to, from) {
      if (from.params.id && to.params.id) {
        this.$router.go(to);
      }
    },
  },
  created() {
    if (this.authenticatedUser) {
      this.getGroup();
    }

    eventBus.$on("sendAAA", (value13) => {
      this.value3 = value13;
    });

    eventBus.$on("MemberToBeExpelled", (b) => {
      this.MemberToBeExpelled = b;

      this.$bvModal.show("modal-expell");
    });
  },
  components: { MembersSection, Autocomplete },
  computed: {
    ...mapGetters(["authenticatedUser"]),

    isCreatedbyOwner: function () {
      if (this.UserLogin === this.group.creator.login) {
        return true;
      } else {
        return false;
      }
    },

    getOwner() {
      if (this.group.creator.name !== undefined) {
        return this.group.creator.name;
      }
      return "<Unknown>";
    },
  },
  methods: {
    goToEditView() {
       this.$router.push({ path: '/workspace/groups/'+ this.$route.params.id +'/edit' })      

      
    } ,

    ExpellOk() {
      axios
        .post(
          "/group/groupRejectMember/" +
            this.$route.params.id +
            "?userId=" +
            this.MemberToBeExpelled,
          null,
          { withCredentials: true }
        )
        .then((response) => {
          this.$bvModal.show("modal-expell-Success");
        });
    },
    ExpellSuccessOk() {
      window.location.reload();
    },

    getGroup: function () {
      let groupId = this.$route.params.id;
      this.$store.dispatch("getGroupEntity", groupId).then((response) => {
        this.group = response;
      });
    },

    showMsgLeave(groupId) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to leave this group.", {
          title: "Are you sure you want to leave this group?",
          size: "bg",
          buttonSize: "bg",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (this.boxTwo) {
            this.leaveGroup(groupId);
          } else {
          }
        })
        .catch((error) => {
          alert("An error occurred! Please refresh the page." + error);
        });
    },

    showMsgInvite() {
      this.$bvModal.show("modal-invite");
    },

    handleInvitationOk() {
      axios
        .get("/user/byLogin?login=" + this.value3, {
          withCredentials: true,
        })
        .then((response) => {
          this.userID2 = response.data.id;

          axios
            .get("/group/" + this.$route.params.id, {
              withCredentials: true,
            })
            .then((response) => {
              var MemberConsent = response.data.needMemberConsent;

              axios
                .post(
                  "/group/groupAcceptMember/" +
                    this.$route.params.id +
                    "?userId=" +
                    this.userID2,
                  null,
                  {
                    withCredentials: true,
                  }
                )
                .then((response) => {
                  if (MemberConsent === true) {
                    this.$bvModal.show("modal-4");
                  } else {
                    this.$bvModal.show("modal-3");
                  }
                })
                .catch((err) => {
                  this.$bvModal.show("modal-2");
                });
            });
        });
    },

    AcceptOk() {
      axios
        .get("/user/byLogin?login=" + this.value3, {
          withCredentials: true,
        })
        .then((response) => {
          this.userID2 = response.data.id;

          axios
            .post(
              "/group/groupAcceptMember/" +
                this.$route.params.id +
                "?userId=" +
                this.userID2,
              null,
              {
                withCredentials: true,
              }
            )
            .then((response) => {
              this.$bvModal.show("modal-2");
            })
            .catch((err) => {
              this.$bvModal.show("modal-2");
            });
        });
    },
    RejectCancel() {
      axios
        .get("/user/byLogin?login=" + this.value3, {
          withCredentials: true,
        })
        .then((response) => {
          this.userID2 = response.data.id;

          axios
            .post(
              "/group/groupRejectMember/" +
                this.$route.params.id +
                "?userId=" +
                this.userID2,
              null,
              {
                withCredentials: true,
              }
            )
            .then((response) => {});
        });
    },

    showMsgAcceptReject(groupId2) {
      this.$bvModal.show("modal-9");
    },

    showMsgDelete(groupId) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete this group.", {
          title: "Are you sure you want to delete this group?",
          size: "bg",
          buttonSize: "bg",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (this.boxTwo) {
            this.deleteGroup();
          } else {
          }
        })
        .catch((error) => {
          alert("An error occurred! Please refresh the page." + error);
        });
    },

    deleteGroup: function () {
      let groupId = this.$route.params.id;
      this.$store.dispatch("deleteGroup", groupId)
      .then( () => {  
        this.$router.push({ name: "groups" });
        window.location.reload()        

      })

    },

    leaveGroup: function (groupId) {
      this.$store.dispatch("leaveGroup", groupId).then((data) => {
        this.$router.push({ name: "groups" });
      });
    },
  },
  filters: {
    needConsent(option) {
      if (option === true) {
        return "Yes";
      }
      return "No";
    },
  },
};
</script>

<style scoped>
#media-wrapper {
  width: 128px;
  height: 128px;
}
</style>



// WEBPACK FOOTER //
// src/views/GroupView.vue